import { h, Host } from "@stencil/core";
/** A default header for [`es-table-detail`](/components/components/es-table-detail). */
export class TableDetailHeader {
  constructor() {
    this.autoExtract = (name) => {
      const value = this.data?.[name];
      return typeof value === 'string' || typeof value === 'number'
        ? value
        : null;
    };
    this.identifier = 'detail-header';
    this.data = undefined;
    this.titleCell = 'title';
    this.actionsCell = 'actions';
    this.cells = undefined;
  }
  render() {
    const renderTitle = this.cells[this.titleCell]?.cell;
    const renderActions = this.cells[this.actionsCell]?.cell;
    return (h(Host, null, h("h1", { class: 'header_title' }, renderTitle
      ? renderTitle(h, {
        data: this.data,
        parent: this.identifier,
        key: this.identifier,
      })
      : this.autoExtract(this.titleCell)), renderActions && (h("div", { class: 'header_actions' }, renderActions(h, {
      data: this.data,
      parent: this.identifier,
      key: this.identifier,
    })))));
  }
  static get is() { return "es-table-detail-header"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-table-detail-header.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-table-detail-header.css"]
    };
  }
  static get properties() {
    return {
      "identifier": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Passed to cell renderer as `parent`."
        },
        "attribute": "identifier",
        "reflect": false,
        "defaultValue": "'detail-header'"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The data to render."
        },
        "attribute": "data",
        "reflect": false
      },
      "titleCell": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Which cell to place as the title"
        },
        "attribute": "title-cell",
        "reflect": false,
        "defaultValue": "'title'"
      },
      "actionsCell": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Which cell to place in the top right as a list of actions."
        },
        "attribute": "actions-cell",
        "reflect": false,
        "defaultValue": "'actions'"
      },
      "cells": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TableCells<any, any>",
          "resolved": "{ [x: string]: TableCell<any, any>; }",
          "references": {
            "TableCells": {
              "location": "import",
              "path": "../types",
              "id": "src/components/tables/types.ts::TableCells"
            }
          }
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "A record of table cell definitions."
        }
      }
    };
  }
}
//# sourceMappingURL=es-table-detail-header.js.map
